import { messageTypes } from '../components/Messages';

export default (message) => (value) => {
    let result;
    if (!value || !value.trim().length) {
        result = { title: message, type: messageTypes.information };
    }
    return result;
};
